import useResources from "./use-resources";

export default function useTenantAutoActions(tenantId) {
  const {
    resources: tenantAutoActions,
    error,
    isLoading,
    create,
    update,
    del,
    mutate,
  } = useResources(tenantId ? `tenants/${tenantId}/auto-actions` : null);

  return {
    tenantAutoActions,
    error,
    isLoading,
    createTenantAutoAction: create,
    deleteTenantAutoAction: del,
    updateTenantAutoAction: update,
    refresh: () => mutate(),
  };
}
